import React, { useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import './Filter_Sort_By_Modal.css'
import RedRoundBtn from '../../Common_Btn/RedRoundBtn/RedRoundBtn'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Filter_Sort_By_Modal = (props) => {

    const feature = ["Sort by", "Plan type", "Payout option", "Insurer", "Premium pay type"]

    const data = ["Popularity", "Premium: Low to High", "Premium: High to Low", "Claim Settlement Ratio: Low to High", "Claim Settlement Ratio: High to Low"]

    const planTypeData = ["Zero Cost Plan", "Return of Premium Plans", "Return of Premium Plans (>2 times)", "Increasing Cover Plans", "Get Covereage upto 100 years"]

    const payOutData = ["Lumpsum Payout", "Monthly Income", "Lumpsum Amount + Monthly Income",]

    const payTypeData = ["Regular Pay", "Limited Pay", "Single Pay"]

    const images = [
        "/assets/Image/aboutus/partner/img1.png",
        "/assets/Image/aboutus/partner/img2.png",
        "/assets/Image/aboutus/partner/img3.png",
        "/assets/Image/aboutus/partner/img4.png",
        "/assets/Image/aboutus/partner/img5.png",
        "/assets/Image/aboutus/partner/img6.png",
    ]

    const [activeFeature, setActiveFeature] = useState("Sort by");

    return (
        <section className='ComparePlansModal'>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="Filter_Sort_By_Modal common_modal"
            >
                <Modal.Header>
                    <Modal.Title>Filter / Sort by</Modal.Title>
                    <div className='close_icon_holder' onClick={() => { props?.onHide() }}>
                        <FontAwesomeIcon icon={faXmark} className='close_icon' />
                    </div>
                </Modal.Header>

                <Modal.Body>

                    <div className='contet_holder'>
                        <div className='row'>

                            <div className='col-lg-4'>
                                <div className='sort_by_div'>
                                    {/* <div className='title_div'>
                                        <p className='title_text'>Sort by</p>
                                        <p className='sub_text'>Popularity</p>
                                    </div> */}

                                    {feature?.map((item) => {
                                        return (
                                            <div
                                                className={`feature_div ${activeFeature === item ? "active" : ""}`}
                                                onClick={() => setActiveFeature(item)}
                                            >
                                                <p className='text'>{item}</p>
                                                {activeFeature === "Sort by" && item === "Sort by" && (
                                                    <p className='sub_text'>Popularity</p>
                                                )}
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>

                            <div className='col-lg-8'>

                                <div className='right_side_card'>




                                    <div className='content_text'>

                                        {activeFeature === "Sort by" && (
                                            <>
                                                {data?.map((item) => {
                                                    return (
                                                        <>
                                                            <p className='black_radio'>
                                                                <Form.Check
                                                                    type="radio"
                                                                    name="name"
                                                                    label={item}
                                                                />
                                                            </p>
                                                        </>

                                                    )
                                                })}
                                            </>
                                        )}

                                        {activeFeature === "Plan type" && (
                                            <>
                                                {planTypeData?.map((item) => {
                                                    return (
                                                        <>
                                                            <p className='black_radio'>
                                                                <Form.Check
                                                                    type="radio"
                                                                    name="name"
                                                                    label={item}
                                                                />

                                                                <p className='subtext'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                                                                    has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                                                                    of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also
                                                                    the leap into electronic typesetting, remaining essentially unchanged.
                                                                </p>
                                                            </p>
                                                        </>

                                                    )
                                                })}
                                            </>
                                        )}

                                        {activeFeature === "Payout option" && (
                                            <>

                                                <p className='title_text'>In your absence your family will receive the cover amount as</p>

                                                {payOutData?.map((item) => {
                                                    return (
                                                        <>
                                                            <p className='black_radio'>
                                                                <Form.Check
                                                                    type="radio"
                                                                    name="name"
                                                                    label={item}
                                                                />

                                                                <p className='subtext'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                                                                    has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                                                                    of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also
                                                                    the leap into electronic typesetting, remaining essentially unchanged.
                                                                </p>
                                                            </p>
                                                        </>

                                                    )
                                                })}
                                            </>
                                        )}

                                        {activeFeature === "Insurer" && (
                                            <>

                                                <p className='title_text'>Select Insurer</p>

                                                <div className='partner_main_div'>
                                                    <div className='row'>
                                                        {images?.map((item) => {
                                                            return (
                                                                <div className='col-lg-3 col-md-3 col-sm-3 col-4 me-0 ms-0 p-0'>
                                                                    <div className='img_holder'>
                                                                        <img src={item} className='inner_img' />
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </>
                                        )}


                                        {activeFeature === "Premium pay type" && (
                                            <>

                                                <p className='title_text'>How do you wish to pay?</p>

                                                {payTypeData?.map((item) => {
                                                    return (
                                                        <>
                                                            <div className='text_container'>
                                                                <div>
                                                                    <p className='black_radio custom_radio'>
                                                                        <Form.Check
                                                                            type="radio"
                                                                            name="name"
                                                                            label={item}
                                                                        />
                                                                    </p>
                                                                </div>
                                                                <div>
                                                                    <p className='green_round_text'>
                                                                        Save upto 42%
                                                                    </p>
                                                                </div>
                                                            </div>

                                                        </>

                                                    )
                                                })}
                                            </>
                                        )}

                                    </div>

                                    <div className='footer_part'>
                                        <p className='clear_text'>Clear All</p>
                                        <div className='btn_holder'>
                                            <RedRoundBtn btn_name="Apply" onClick={() => {
                                                props?.onHide()
                                                setTimeout(() => {
                                                    props?.setShowSuccessModal(true)
                                                }, 300);
                                            }} />
                                        </div>
                                    </div>

                                </div>



                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </section >
    )
}

export default Filter_Sort_By_Modal
